export function isMp() {
    const { wx } = globalThis;
    if (typeof wx === 'undefined') {
        return false;
    }
    if (globalThis.Page === undefined) {
        return false;
    }
    if (!wx.getSystemInfoSync) {
        return false;
    }
    if (!wx.getStorageSync) {
        return false;
    }
    if (!wx.setStorageSync) {
        return false;
    }
    if (!wx.connectSocket) {
        return false;
    }
    if (!wx.request) {
        return false;
    }
    try {
        if (!wx.getSystemInfoSync()) {
            return false;
        }
        if (wx.getSystemInfoSync().AppPlatform === 'qq') {
            return false;
        }
    }
    catch (e) {
        return false;
    }
    return true;
}
let IS_IN_MP_WEBVIEW = false;
function ready() {
    IS_IN_MP_WEBVIEW = IS_IN_MP_WEBVIEW || (typeof window !== undefined && window.__wxjs_environment === 'miniprogram');
}
try {
    if (!isMp()) {
        IS_IN_MP_WEBVIEW = IS_IN_MP_WEBVIEW
            || !!navigator.userAgent.match(/miniprogram/i)
            || window.__wxjs_environment === 'miniprogram';
        if (window && window.WeixinJSBridge && window.WeixinJSBridge.invoke) {
            ready();
        }
        else if (typeof document !== 'undefined') {
            document.addEventListener('WeixinJSBridgeReady', ready, false);
        }
    }
}
catch (e) { }
export function isInMpWebView() {
    return IS_IN_MP_WEBVIEW;
}
